import React, { Component } from "react";
import aidao from "./../../assets/images/Aidao_navy.svg";
import ether from "./../../assets/images/Ethereum.svg";
import { Link } from "react-router-dom";
import $ from "jquery";

export default class LeftSideBar extends Component {
  render() {

    var username = window.username;

    $("#sidebar-menu a").each(function() {
      if (this.href === window.location.href) {
        $(this).addClass("active");
        $(this)
          .parent()
          .addClass("active"); // add active to li of the current link
      } else if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this)
          .parent()
          .removeClass("active"); // add active to li of the current link
      }
    });


    var data = this.props.data;

    return (
      <div class="left side-menu">
        <div class="sidebar-inner slimscrollleft">
          <div class="slimscrollbar">
            <div class="user-box">
              <h5>
                Welcome back, <a> {username} </a>{" "}
              </h5>
            </div>

            <div id="sidebar-menu">
              <ul>
                <li>
                  <Link to={{ pathname: "/dashboard" }} class="waves-effect">
                    <i class="fa fa-home" /> <span> {data.dashboard} </span>{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to={{ pathname: "/dashboard/account" }}
                    class="waves-effect"
                  >
                    <i class="fa fa-lock" /> <span> {data.account} </span>{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to={{ pathname: "/dashboard/security" }}
                    class="waves-effect"
                  >
                    <i class="fa fa-key" />
                    <span> {data.security} </span>{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to={{ pathname: "/dashboard/notification" }}
                    class="waves-effect"
                  >
                    <i class="fa fa-book" /> <span> {data.information} </span>{" "}
                  </Link>
                </li>
                <li />

                <li>
                    <Link to={{ pathname:'/dashboard/swapcenter' }} class="waves-effect"><i class="fa fa-exchange"></i> <span> Swap Center </span> </Link>
                </li>


                <li>
                  <Link
                    to={{ pathname: "/dashboard/history" }}
                    class="waves-effect"
                  >
                    <i class="fa fa-history" /> <span> {data.history} </span>{" "}
                  </Link>
                </li>

                <li>
                  <Link
                    to={{ pathname: "/dashboard/tokenpage" }}
                    class="waves-effect"
                  >
                    <i class="fa fa-cubes" /> <span> {data.tokenpage} </span>{" "}
                  </Link>
                </li>


                <li class="menu-title" />
                <li class="token-list">
                  <Link
                    to={{ pathname: "/dashboard/aidao" }}
                    class="waves-effect"
                  >
                    <img src={aidao} alt="aidao icon" />
                    <span> DAO</span>
                  </Link>
                </li>
                <li class="token-list">
                  <Link
                    to={{ pathname: "/dashboard/ethereum" }}
                    class="waves-effect"
                  >
                    <img src={ether} alt="ether icon" />
                    <span> Ethereum</span>
                  </Link>
                </li>
              </ul>
              <div class="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/leftsidebar.js